"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var InputAction_1 = __importDefault(require("./InputAction"));
exports.Input = InputAction_1.default;
exports.default = InputAction_1.default;
//# sourceMappingURL=index.js.map